module.exports = __webpack_public_path__ + "static/media/fvs_hamburgerKunsthalle_27.46aeaf3a.jpg";